/**=========================================================
 * Module: workloads.js
 * Workloads Controller
 =========================================================*/

 App.controller('WorkloadsController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService','$filter',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter) {
   "use strict";
    
   $scope.page = {
      title: 'sidebar.nav.WORKLOADS',
      subTitle: ''
   };
  
   $scope.model = {
      
   }
   $scope.loadedAccounts = [];
   $scope.usersById = {};
   $scope.tabs = '';
   $scope.view = {};

   $scope.status = {
    loadingProjects: true,
    loadingAnalysis: false
   };

   $scope.types = ['projects', 'standby', 'combinations', 'words', 'norm', 'recovered', 'clients', 'urgent', 'delivery'];
   $scope.sets = ['total','open','quotation','running'];
     
   var clients = {};

   D.query('group','type=client', { cache: false }).then(
     function(response){
       for(var i=0;i<response.length; i++){
        clients[response[i].id] = response[i].name;
       }

       D.query('account', 'group=adm', { cache: false }).then(
        function(response){
          response = response.filter(function(a) { return a.enabled; })
          $scope.users = response;
          for(var i=0; i<response.length; i++){
            $scope.usersById[response[i].id] = response[i];
          }
    
          $scope.form = {
            title: '',
            status: '',
            type: 'account',
            model: $scope.model,
            fields: [
                {
                    available: true,
                    type: 'checkboxes',
                    name: 'account',
                    valueField: 'id',
                    labelField: 'name',
                    data: $scope.users
                },{
                  available: true,
                  type: 'submit',
                  label: 'labels.SEND'
                }
              ],
              submit: function(){
                $scope.loadedAccounts = [];
                $scope.model = { account: $scope.form.model.account };
                $scope.count = $scope.model.account.length;
                for(var i=0; i<$scope.model.account.length; i++)
                  getWorkloads($scope.model.account[i]);
              }
            }
    
          
    
        }).catch(console.error);


     }
   ).catch(console.error);

  $scope.setTabs = function(id){
    $scope.tabs=id;
  }


   function getWorkloads(id){
     if($rootScope.user.admin && $rootScope.user.role=='SUPERADMIN'){
      if(!$scope.tabs) $scope.tabs=id;
      $scope.status.selectedUser = true;
      $scope.status.loadingProjects = true;
      D.query('project','assignee='+id+'&statusgroup=open|running&_range=-1&_withAnalysis=true').then(
        function(response){
          $scope.count--;
          if($scope.count==0){
            $scope.status.loadingProjects = false;
          }
          for(var i=0; i<response.length; i++){
            var p = response[i];
            p.a = JSON.parse(p.a);
            var sets = [];
            if('ANALYSIS|SENT'.indexOf(p.status)>=0){
              sets.push('total');
              sets.push('open');
            } else if('REVISION|ESTIMATION'.indexOf(p.status)>=0){
              sets.push('total');
              sets.push('quotation');
            } else if('CONFIRMED|PROCESSING'.indexOf(p.status)>=0){
              sets.push('total');
              sets.push('running');
            } else {

            }
            var status = $filter('translate')('enums.status.'+p.status);
            for(var j=0; j<sets.length; j++){
              var s = sets[j];
              if(p.standby){
                count(id, {key:p.code}, 'standby', s);
              } else {
                count(id, {key:p.code,value:status}, 'projects', s);
                combinations(id, p, s);
                count(id, {key:p.code,value:p.a.total}, 'words', s, p.a.total);
                count(id, {key:p.code,value:p.a.normTotal}, 'norm', s, p.a.normTotal);
                distinct(id, {key:clients[p.group],value:1}, 'clients', s);
                count(id, {key:p.code,value:p.recoveredWords}, 'recovered', s, p.recoveredWords);
                count(id, {key:p.code,value:p.urgentOffer ? p.delivery : null}, 'urgent', s, p.urgentOffer ? 1 : 0);
                avg(id, {key:p.code,value:p.delivery}, 'delivery', s, p.delivery);
              }
            }
          }
          $scope.loadedAccounts.push(id);
        }
      ).catch(console.error);
    }
   }
   

    function count(id, p, type, set, value){
      if(!$scope.model[type]) $scope.model[type] = {};
      if(!$scope.model[type][set]) {
        $scope.model[type][set] = {};
        $scope.model[type][set+'_counter'] = {};
      }
      if(!$scope.model[type][set][id]) {
        $scope.model[type][set][id] = 0;
        $scope.model[type][set+'_counter'][id] = 0;
      }
      if(value!==undefined)
        $scope.model[type][set][id]+=value;
      else
        $scope.model[type][set][id]++;
      $scope.model[type][set+'_counter'][id]++;
      if(p){
        if(!$scope.model[type][set+'_list']) $scope.model[type][set+'_list'] = {};
        if(!$scope.model[type][set+'_list'][id]) $scope.model[type][set+'_list'][id] = [];
        var found = false;
        for(var i=0; i<$scope.model[type][set+'_list'][id].length; i++){
          if($scope.model[type][set+'_list'][id][i].key==p.key){
            found = true;
            $scope.model[type][set+'_list'][id][i].value += p.value;
          } 
        }
        if(!found && p.value!==null) $scope.model[type][set+'_list'][id].push(p)
        
      }
    }

    function distinct(id, p, type, set, value){
      count(id, p, type, set, value);
      $scope.model[type][set][id] = $scope.model[type][set+'_list'][id].length;
    }

    function avg(id, p, type, set, value){
      if($scope.model[type] && $scope.model[type][set] && $scope.model[type][set][id]!==undefined){
        $scope.model[type][set][id] = $scope.model[type][set][id] * $scope.model[type][set+'_counter'][id];
      }
      count(id, p, type, set, value);
      $scope.model[type][set][id] = $scope.model[type][set][id] / $scope.model[type][set+'_counter'][id];
    }


    function combinations(id, p, set){
      for(var i=0; i<p.destinations.length; i++){
        count(id, {key: $filter('translate')('enums.language.'+p.source) + ' → ' + $filter('translate')('enums.language.'+p.destinations[i]) , value: 1}, 'combinations', set);
      }
    }

    $scope.exportToExcel = function exportToExcel(){
      var csv = "";
      var uri = 'data:application/vnd.ms-excel;base64,';
      var base64 = function(s) {
          return window.btoa(unescape(encodeURIComponent(s)))
      };

      var c = $rootScope.user.csvSep;

      for(var k in $scope.sets){
        var s = $scope.sets[k];
        if(k>0)csv+='\n';
        csv+=$filter('translate')('labels.WL'+s.toUpperCase())+'\n';
        csv+=c;
        for(var i in $scope.loadedAccounts){
          csv += $scope.usersById[$scope.loadedAccounts[i]].name + c;
        }
        csv+='\n';
        for(var i in $scope.types){
          var type = $scope.types[i];
          csv += $filter('translate')('labels.WL' + type.toUpperCase()) + c;
          for(var j in $scope.loadedAccounts){
            var value = $scope.model[type][s] ? ($scope.model[type][s][$scope.loadedAccounts[j]] || 0) : 0;
            if(type=='delivery' && value) value = moment(value).format($rootScope.user.dateFormat);
            if(type=='delivery' && !value) value = '-';
            csv += value + c;
          }
          csv += '\n';
        }
      }

      var link = document.createElement("a");
      link.download = "workloads_"+moment().format('YYYYMMDD')+".csv";
      link.href = uri + base64(csv);
      //link.href = uri + base64(format(template, ctx));
      link.click();
    };
     
 }
 ]);